// Контактные данные
export const CONTACTS = {
  phone: "+201222209569",
  whatsapp: "201222209569", // общий номер (по умолчанию Hurghada)
  whatsappHurghada: "201222209569",
  whatsappAlAhyaa: "201211688666",
  telegram: "201222209569",
};

// Стоимость доставки
export const DELIVERY_COST = 50;

// Placeholder изображения
export const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='250' height='250'%3E%3Crect fill='%23ddd' width='250' height='250'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-size='20'%3EИзображение%3C/text%3E%3C/svg%3E";

export const PLACEHOLDER_IMAGE_SMALL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Crect fill='%23ddd' width='80' height='80'/%3E%3C/svg%3E";
